// Anonymous page-view beacon. Fires on every route change once axios/API is ready.
// Persists a stable `visitor_id` in localStorage, refreshes a per-tab `session_id`
// on every page load, and never blocks navigation (fire-and-forget).
import axios from "axios";

const VISITOR_KEY = "yorm_visitor_id";
const SESSION_KEY = "yorm_pv_session";

function makeId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `v-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
}

export function getVisitorId() {
  try {
    let id = localStorage.getItem(VISITOR_KEY);
    if (!id) {
      id = makeId();
      localStorage.setItem(VISITOR_KEY, id);
    }
    return id;
  } catch {
    return "no-storage";
  }
}

export function getSessionId() {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = makeId();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return "no-session";
  }
}

export async function trackPageView({ api, path, userId, role, isNative }) {
  if (!api || !path) return;
  const payload = {
    visitor_id: getVisitorId(),
    session_id: getSessionId(),
    path,
    referrer: (typeof document !== "undefined" && document.referrer) || null,
    language: (typeof navigator !== "undefined" && navigator.language) || null,
    screen:
      typeof window !== "undefined" && window.screen
        ? `${window.screen.width}x${window.screen.height}`
        : null,
    user_id: userId || null,
    role: role || null,
    is_native: !!isNative,
  };
  try {
    await axios.post(`${api}/analytics/pageview`, payload, { timeout: 5000 });
  } catch {
    // Silent — analytics must never break UX
  }
}
